interface Stage {
  name: string
  color: string
}

interface StageChipProps {
  stage: Stage
  size?: "sm" | "md"
  className?: string
}

function getContrastColor(hexColor: string): string {
  const hex = hexColor.replace("#", "")
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.5 ? "#000000" : "#ffffff"
}

export function StageChip({ stage, size = "md", className = "" }: StageChipProps) {
  const ink = getContrastColor(stage.color)
  const padding = size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-[3px] font-mono font-semibold uppercase tracking-[0.06em] leading-none whitespace-nowrap ${padding} ${className}`}
      style={{ backgroundColor: stage.color, color: ink }}
    >
      <span
        className="w-[5px] h-[5px] rounded-full"
        style={{ backgroundColor: ink, opacity: 0.7 }}
      />
      {stage.name}
    </span>
  )
}
